import { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  PayPalScriptProvider,
  PayPalMessages,
  usePayPalScriptReducer,
} from "@paypal/react-paypal-js";
import { PAYPAL_CLIENT_ID } from "../../../../utils/paypalKeys";
import SpinnerLoading from "../../../shared/spinnerLoading/SpinnerLoading";

const PaypalMessagesInside = (totalePrezzo = "0") => {
  useEffect(() => {
    /* console.log(
      "amount 2",
      parseFloat(totalePrezzo.totalePrezzo).toFixed(2),
      totalePrezzo
    ); */
  }, [totalePrezzo]);

  const [{ isPending }] = usePayPalScriptReducer();
  const amount = parseFloat(totalePrezzo.totalePrezzo).toFixed(2);
  const currency = "EUR";
  const style = {
    layout: "text",
    logo: {
      type: "inline",
    },
  };
  const showMessages = (
    <PayPalMessages
      style={style}
      disabled={false}
      currency={currency}
      amount={amount}
      forceReRender={[amount, currency, style]}
    />
  );

  return (
    <Fragment>
      {isPending ? <SpinnerLoading /> : null}
      {showMessages}
    </Fragment>
  );
};

const PaypalMessages = (totalePrezzo = "0") => {
  const currentPage = useSelector((state) => state.currentPage);
  const suffissoLang = currentPage.currentLang.replace("_", "");
  // opzione configurazione Paypal (passo anche lingua)
  let langPaypal = `${suffissoLang}_${suffissoLang.toUpperCase()}`;
  langPaypal = langPaypal === "en_EN" ? "en_GB" : langPaypal;
  useEffect(() => {
    /* console.log(
      "amount 1",
      parseFloat(totalePrezzo.totalePrezzo).toFixed(2),
      totalePrezzo
    ); */
  }, [totalePrezzo]);
  const initialOptions = {
    "client-id": PAYPAL_CLIENT_ID,
    currency: "EUR",
    locale: langPaypal,
    components: "messages,buttons",
  };
  return (
    <PayPalScriptProvider options={initialOptions}>
      <PaypalMessagesInside totalePrezzo={totalePrezzo.totalePrezzo} />
    </PayPalScriptProvider>
  );
};

export default PaypalMessages;
